import React from 'react';
import moment from 'moment-timezone';
import FieldGuide from '../form/fields/common/fieldGuide';
import Tag from '../common/tags';

const getLocalFormattedTime = (date, format = 'MM/DD/YYYY, hh:mm A') => {
  const localZone = moment.tz.guess();

  return `${moment
    .utc(date)
    .local()
    .format(format)} ${moment.tz.zone(localZone).abbr(360)}`;
};

const getLastComment = data => {
  if (data.length <= 40) return data;

  let comment = data.substring(0, 39);
  comment += '...';
  return (
    <>
      {comment}
      <div className="responsive-table__comment-guide">
        <FieldGuide tooltip={data} />
      </div>
    </>
  );
};

const getMessage = (message) => {
  return (
    <div className="responsive-table__messages">
        <Tag
          tagLabel={message}
        />
    </div>
  );
};

export { getLocalFormattedTime, getLastComment, getMessage };
